import {useContext} from 'react'
import {Container} from './styles'
import AppContext from '../../../context/AppContext'
import CareerNewbieHero from './Hero';
import CareerNewbieHotEvents from './HotEvents';
import {IEvent} from '../../Event/assets/types';
import JobRecommendationSection from '../components/JobRecommendation';
import ToolBanners from '../ToolBanners';
import HRInsider from '../HRInsider';
import {ELanguage} from '@microfrontends/react-components';
import CareerBanners from '../CareerBanners';
import PodcastSection from './Podcast';
import CompanionBusiness from './CompanionBusiness';
import Contact from './Contact';
import {EJobLevel} from '../types';

interface ICareerNewbiePageProps{
	isRobot: boolean
	events: IEvent[]
}
export interface IImageSource {
	background: string, paper: string, primaryEntity: string, subLabel: string
}


export function clampFunc({min, max}, {minWidthPx = 992, maxWidthPx = 1600}) {
	const pixelsPerRem = 14
	const minFontSize = min/pixelsPerRem
	const maxFontSize = max/pixelsPerRem
	const minWidth = minWidthPx / pixelsPerRem;
	const maxWidth = maxWidthPx / pixelsPerRem;
	
	const slope = (maxFontSize - minFontSize) / (maxWidth - minWidth);
	const yAxisIntersection = -minWidth * slope + minFontSize;
	
	return `clamp(${minFontSize}rem, ${yAxisIntersection.toFixed(
		4
	)}rem + ${(slope * 100).toFixed(4)}vw, ${maxFontSize}rem);`
}


export const BASE_URL =  `${process.env.APP_BASE_URL}` ?? '/'
export const assetUrl = (fileName: string) => `${process.env.BASE_IMAGES_URL}/images/career-newbies/${fileName}`
const topBackgroundUrl = assetUrl('bg.jpg')
const CareerNewbieLandingPage = ({events} : ICareerNewbiePageProps) => {
	const { languageCode = ELanguage.VI, data, isBot } = useContext(AppContext)
	return (
		<Container topBackgroundImage={topBackgroundUrl}>
			<CareerNewbieHero/>
			<CareerNewbieHotEvents utm={data.utm} events={events}/>
			<JobRecommendationSection id={'viec-lam-entry'} jobLevelId={EJobLevel.Fresher} sectionTitle="VIỆC LÀM TỐT NHẤT DÀNH CHO Entry Level" lightTitleColor={true} jobList={data.jobs.fresher}/>
			<ToolBanners/>
			<JobRecommendationSection id={'viec-lam-internship'} jobLevelId={EJobLevel.Intern} sectionTitle="VIỆC LÀM THỰC TẬP SINH" jobList={data.jobs.intern}/>
			<HRInsider id='emagazine' utm={data.utm} language={ELanguage.VI} title="Emagazine sự nghiệp" layout='grid' tagIds={[41752]} limit={5}/>
			<CareerBanners/>
			<PodcastSection podcastData={data.podcast}/>
			<HRInsider id='blog-hanh-trang-fresher' utm={data.utm} language={ELanguage.VI} title="BLOG HÀNH TRANG FRESHER" layout='list' tagIds={[40956,40957,40958,40959,41752,41780]} limit={20} isBot={isBot}/>
			<CompanionBusiness companies={data.companionBusiness}/>
			<Contact/>
		</Container>
	)
}

export default CareerNewbieLandingPage
